import { PromoCodeSuccessProps } from './types'
import { Banner, Button } from '@boltenergy-be/design-system'
import styles from 'components/promo-code/PromoCode.module.scss'
import parse from 'html-react-parser'
import { Trans, useTranslation } from 'next-i18next/pages'
import { isReferralCode } from './utils'
import { PRODUCT_PROMO_CODES } from 'components/promo-code/constants'
import { useGetLanguage } from 'hooks/useGetLanguage'

const PromoCodeSuccess = ({ variant, showTerms, promoReferralCode }: PromoCodeSuccessProps) => {
  // i18n
  const { t } = useTranslation()
  const language = useGetLanguage()

  // Constants
  const codeIsReferral = isReferralCode(promoReferralCode)
  const context = codeIsReferral ? 'referral' : 'promo'
  const title =
    codeIsReferral || (!codeIsReferral && !PRODUCT_PROMO_CODES.has(promoReferralCode?.code))
      ? t(($) => $.promoCode.result[variant].title, {
          context,
          code: promoReferralCode.code,
          name: codeIsReferral ? promoReferralCode.referrer.firstName : undefined
        })
      : undefined
  const description = !codeIsReferral && 'translations' in promoReferralCode && promoReferralCode.translations[language]

  return variant === 'inline' ? (
    <Banner type="positive" {...{ title }}>
      {!codeIsReferral && (
        <p>
          {parse(description || '')}
          <Trans
            {...{ t }}
            i18nKey={($) => $.promoCode.result.inline.readMore}
            components={{
              terms: (
                <Button
                  representation="link"
                  variant="inline"
                  className={styles['terms-action']}
                  onClick={() => showTerms(codeIsReferral ? 'referral' : 'promo')}
                />
              )
            }}
          />
        </p>
      )}
    </Banner>
  ) : (
    <div className={styles['promo-success']}>
      {title && <span>{parse(title)}</span>}

      {description && <p>{parse(description)}</p>}

      <Button
        representation="link"
        variant="inline"
        className={styles['terms-action']}
        onClick={() => showTerms(codeIsReferral ? 'referral' : 'promo')}
      >
        {t(($) => $.promoCode.terms)}
      </Button>
    </div>
  )
}

export default PromoCodeSuccess
